import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()

const getAllApprovalList = (params) => AxiosClient.get('/approval', {...params});
const updateApprovalStatus = (approval, payload) => AxiosClient.put(`/approval/${approval}`, payload);

export {
    getAllApprovalList,
    updateApprovalStatus
}